import { COUNTRY_CODES, type CreateOrganizationInput } from '@noconflict/contracts';
import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';

export type Values = CreateOrganizationInput;

/** Same rules as the contract's `createOrganizationInputSchema`, with messages from the catalogue. */
export const schema = z.object({
  name: z
    .string()
    .trim()
    .min(1, validationMessage('orgNameRequired'))
    .max(80, validationMessage('orgNameMax')),
  country: z.enum(COUNTRY_CODES, validationMessage('countryRequired')),
});
export type Input = z.input<typeof schema>;
